import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 20"
      className="design-iconfont"
    >
      <path d="m10.863 2.813 2.357 2.428-1.704 1.757-2.358-2.429 1.705-1.756Zm3.262 14.385c.481 0 .875.405.875.901s-.394.901-.875.901H1.875c-.48 0-.875-.405-.875-.901s.394-.901.875-.901Zm-4.42-15.74c.614-.636 1.728-.604 2.377.062l2.395 2.467c.67.69.698 1.788.06 2.446l-7.872 8.106a1.707 1.707 0 0 1-1.062.513l-3.649.34a.863.863 0 0 1-.698-.26.922.922 0 0 1-.253-.718l.332-3.757a1.8 1.8 0 0 1 .499-1.094Z" />
    </svg>
  )
}

const EditIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
EditIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-primary-color))',
}
// 参数类型
EditIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}
export default EditIcon
